import { isInView } from "../../../utils/isInView";

(function() {
    "use strict";
    const navSticky = document.querySelector('.js-nav-page');

    if (navSticky) {
        const navMenu = document.getElementById("navigation-menu"),
            scrollOffset = 62, // Bootstrap Scrollspy offset - 2px
            links = navSticky.querySelectorAll('.js-nav-page-link'),
            navMenuBtn = document.getElementById("industry-nav-button"),
            helper = window.squiz.fn;

        /*
         * When using browser default behaviour, the sticky nav
         * links scroll to the wrong position. Offset the Y
         * scroll position to fix it.
         */
        [...links].forEach(link => {
            link.addEventListener('click', (ev) => {
                ev.preventDefault();
                navMenu.style.display = "none";
                navMenuBtn.style.cssText = "pointer-events: none;";

                const url = new URL(ev.currentTarget.href),
                    targetId = url.hash.replace(/^#/, ''),
                    linkTarget = document.getElementById(targetId),
                    totalOffset = linkTarget.getBoundingClientRect().top + pageYOffset - scrollOffset;

                // get the position to scroll to and save it
                helper.setHook("scrollTo", Math.round(totalOffset));

                setTimeout(() => {
                    scrollTo(0, totalOffset);
                }, 100)
            });
        });

        /**
         * make sure that the page has fully scrolled to the 
         * section before it allows the user to interact with the
         * "jump to" button
        */
        window.addEventListener("scroll", function () {
            // get the scroll position and compare against the final scroll position
            helper.getHook("scrollTo", function (value) {
                if (value >= Math.round(window.scrollY)) navMenuBtn.removeAttribute("style");
            });
        });

        window.addEventListener('activate.bs.scrollspy', () => {
            const activeLink = navSticky.querySelector('.js-nav-page-link.active .js-nav-page-link-text');
            const inView = isInView(activeLink, 'full');
            if (!inView) {
                activeLink.scrollIntoView();
            }
        });
    }
})();

// mobile menu dropdown action 
var navMenu = document.getElementById("navigation-menu");
var navMenuBtn = document.getElementById("industry-nav-button");
if (navMenu && navMenuBtn) {
    navMenuBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (navMenu.style.display === "flex") {
            navMenu.style.display = "none";
          } else {
            navMenu.style.display = "flex";
          }
    })

}
